<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Editar Nome do Grupo</span>
      </v-card-title>
      <v-card-text>
        <EconomicGroupForm ref="form" :economic_group="model_economic_group"></EconomicGroupForm>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">
          Cancelar
        </v-btn>
        <v-btn color="blue darken-1" text @click="save" :loading="loading">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'DialogEditEconomicGroupName',
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    model_economic_group: {
      type: Object,
      required: true
    }
  },
  components: {
    EconomicGroupForm: () => import('@/_backoffice/_registrations/components/economic_groups/forms/EconomicGroupForm.vue'),
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true
        Api.EconomicGroup.update(this.model_economic_group).then(() => {
          this.successSaved()
          this.$emit('updated')
        }).catch(() => {
          this.errorUpdated()
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>

